// src/utils/debugLogger.js

const LogLevel = {
 INFO: 'INFO',
 WARN: 'WARN',
 ERROR: 'ERROR',
};

const isDebugMode = process.env.NODE_ENV === 'development';

// Define the logger object
const logger = {
 info: (context, message, ...data) => {
  if (isDebugMode) {
   console.log(
    `[${new Date().toISOString()}] [${LogLevel.INFO}] [${context}] - ${message}`, 
    ...data
   );
  }
 },

 warn: (context, message, ...data) => {
  if (isDebugMode) {
   console.warn(
    `[${new Date().toISOString()}] [${LogLevel.WARN}] [${context}] - ${message}`, 
    ...data
   );
  }
 },

 error: (context, message, ...data) => {
  // Errors should always be logged
  console.error(
   `[${new Date().toISOString()}] [${LogLevel.ERROR}] [${context}] - ${message}`, 
   ...data
  );
 },
};

// --- FIX ---
// Add .log and .debug as aliases that point to .info
// This makes logger.log() and logger.debug() work correctly.
logger.log = logger.info;
logger.debug = logger.info;

// Export *only* the default logger object
export default logger;